import { IconButton } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import SubtitlesIcon from '@mui/icons-material/Subtitles';
import { Badge, Button as ButtonMUI } from '@mui/material';
import { useState } from 'react';
import { v4 as uuid } from 'uuid';
import { IConversationViewModel, IDemandViewModel, ISolicitationViewModel } from 'viewModels';
import { useTheme } from 'styled-components';
import {
  IAddParticipantConversationInputModel,
  IConversationForSolicitationInputModel,
} from 'inputModels';
import { ReactComponent as CloseIcon } from '../../../assets/icons/IconCloseCircle.svg';
import { labelServiceStatus, ServiceStatus } from '../../../types/enums';
import { Button } from '../../Buttons/Button';
import { HistoricService } from '../../HistoricService';
import { ModalFinalizeDemand } from '../../Modals/ModalFinalizeDemand';
import { OptionsEventSolicitations } from '../../OptionsEventSolicitation';
import { SolicitationContentData } from '../../SolicitationContentData';
import { SolicitationMapLocation } from '../../SolicitationMapLocation';
import { TradingSolicitation } from '../../TradingSolicitation/index';
import { Container, Content, Header } from './styles';
import { useApp, useAuth } from '../../../context';
import { useConversation } from '../../../context/conversation';
import { ReactComponent as ChatIcon } from '../../../assets/icons/chat-balloon-icon.svg';
import { ModalChat } from '../../Modals/ModalChat';
import { ModalCancelDemandInProgress } from '../../Modals/ModalCancelDemandInProgress';
import ConversationController from '../../../controller/ConversationController';
import { SolicitationController } from '../../../controller/SolicitationController';
import { useAlert } from '../../../hooks/useAlert';
import { useSolicitation } from '../../../context/solicitation';

//import { SolicitationMapLocation } from '../SolicitationMapLocation';

interface Props {
  demandParam: IDemandViewModel;
  zIndex?: number;
}

export function CardDemandDetails({ demandParam, zIndex }: Props) {
  const [isOpenInformation, setIsOpenInformation] = useState(false);
  const [demand, setDemand] = useState<IDemandViewModel>(demandParam);
  const [isOpenChat, setIsOpenChat] = useState(false);
  const [isOpenCancel, setIsOpenCancel] = useState(false);
  const [conversationIdSelected, setConversationIdSelected] = useState<string>();
  const [isOpenFinalizeDemand, setIsOpenFinalizeDemand] = useState(false);
  const [isOpenLocation, setIsOpenLocation] = useState(false);
  const [isOpenHistoric, setIsOpenHistoric] = useState(false);
  const [isOpenHistoricCanceledDemand, setIsOpenHistoricCanceledDemand] = useState(false);
  const { user } = useAuth();
  const { colors } = useTheme();
  const { conversations, setConversations } = useConversation();
  const { setDemands } = useSolicitation();
  const { setLoading } = useApp();
  const alert = useAlert();

  const handleClickOpenHistoricCanceledDemand = () => {
    setIsOpenHistoricCanceledDemand(!isOpenHistoricCanceledDemand);
  };

  const handleCreateConversationForSolicitation = async (
    solicitationSelected: ISolicitationViewModel,
  ) => {
    if (!user.id) return;
    if (!solicitationSelected.correspondent?.id) return;
    if (!solicitationSelected.id) return;
    const conversation: IConversationForSolicitationInputModel = {
      solicitationId: solicitationSelected.id,
      participants: [user.id, solicitationSelected.correspondent.id!],
    };
    await ConversationController.createConversationForSolicitation(conversation).then(
      (response) => {
        setConversationIdSelected(response);
        const newConversation: IConversationViewModel = {
          isAssistantChat: false,
          id: response,
          messages: [],
          participants: [
            {
              id: user.id,
              firstName: user.firstName,
              lastName: user.lastName,
              profilePictureId: user.profilePictureId,
            },
            {
              id: solicitationSelected.correspondent?.id!,
              firstName: solicitationSelected.correspondent?.firstName,
              lastName: solicitationSelected.correspondent?.lastName,
              profilePictureId: solicitationSelected.correspondent?.profilePictureId,
            },
          ],
        };
        setConversations([...conversations, newConversation]);
        setIsOpenChat(true);
      },
    );
  };

  const handleOpenChat = (conversation: IConversationViewModel) => {
    if (!user.id) return;
    if (!conversation.id) return;
    const userIsParticipant = conversation.participants.some((p) => p.id === user.id);
    if (userIsParticipant) {
      setIsOpenChat(true);
      setConversationIdSelected(conversation.id);
    } else {
      const addParticipant: IAddParticipantConversationInputModel = {
        conversationId: conversation.id,
        participantIds: [user.id],
      };
      ConversationController.addParticipants(addParticipant).then(() => {
        setConversations((prev) => {
          const idxConversation = prev.findIndex((c) => c.id === conversation.id);
          const newConversations = [...prev];
          if (idxConversation !== -1) {
            newConversations[idxConversation].participants.push({
              id: user.id,
              firstName: user.firstName,
              lastName: user.lastName,
              profilePictureId: user.profilePictureId,
            });
          }
          return newConversations;
        });
        setIsOpenChat(true);
        setConversationIdSelected(conversation.id);
      });
    }
  };

  const handleOpenMoreInformationSolicitation = async (demandLoaded: ISolicitationViewModel) => {
    if (isOpenInformation) {
      setIsOpenInformation(false);
      return;
    }
    if (!demandLoaded.isSolicitationFullDataLoaded) {
      setLoading(true);
      await SolicitationController.getById(demandLoaded.id)
        .then((el) => {
          setDemands((prev) => {
            const idxDemand = prev.findIndex((d) => d.id === el.id);
            const newDemands = [...prev];
            if (idxDemand !== -1) {
              newDemands[idxDemand] = el;
            }
            return newDemands;
          });
          setIsOpenInformation(true);
          setDemand(el);
        })
        .catch(() => {
          alert.show({ type: 'error', message: 'Erro ao abrir mais detalhes!' });
        })
        .finally(() => {
          setLoading(false);
        });
    }
    setIsOpenInformation(true);
  };
  const showIconChat = (solicitationSelected: ISolicitationViewModel) => {
    if (!user.id) return null;
    if (!solicitationSelected.correspondent?.id) return null;
    if (!demand?.conversationId) {
      return (
        <IconButton
          onClick={() => {
            handleCreateConversationForSolicitation(solicitationSelected);
          }}>
          <ChatIcon fill={colors.tertiary_500} width="3rem" />
        </IconButton>
      );
    }
    const conversation = conversations.find((c) => c.id === solicitationSelected.conversationId);
    if (!conversation) return null;
    const counterMessage = conversation.messages.flatMap(
      (m) => m.infos?.filter((i) => i.createdById === user.id && !i.isReaded) || [],
    ).length;

    return (
      <IconButton
        onClick={() => {
          handleOpenChat(conversation);
        }}>
        <Badge
          badgeContent={counterMessage}
          sx={{
            '& .MuiBadge-badge': {
              backgroundColor: colors.error_500,
              color: colors.background_white,
            },
          }}>
          <ChatIcon fill={colors.tertiary_500} width="3rem" />
        </Badge>
      </IconButton>
    );
  };

  return (
    <Container status={demand?.status!}>
      {demand && (
        <>
          <Header status={demand.status}>
            {!isOpenInformation && demand.status !== ServiceStatus.CONCLUED ? (
              <div className="container-header-info">
                <div className="icon-title-status">
                  <StickyNote2Icon className="icon-header" />
                  <div className="containerGrid">
                    <div className="containerStatus">
                      {Object.keys(labelServiceStatus)
                        .filter((s) => Number(s) === Number(demand.status))
                        .map((status) => (
                          <p className="statusCard" key={status + uuid}>
                            Status: {labelServiceStatus[status as unknown as ServiceStatus]}
                          </p>
                        ))}
                      <p className="protocol">Número de Protocolo: {demand.protocolNumber}</p>
                    </div>
                    <p className="title">{demand?.correspondence?.name}</p>
                    <p className="createdAt">
                      Criada em:{' '}
                      <span>
                        {new Date(demand.createdAt).toLocaleDateString('pt-BR', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                        })}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="deadline">
                  <p className="specialty">{demand.specialty?.name}</p>
                  {demand.status === ServiceStatus.IN_PROGRESS && showIconChat(demand)}
                  <p className="address">{`
                            ${demand?.address?.street ? `${demand.address.street},` : ''} 
                            ${demand?.address?.number ? `${demand.address?.number},` : ''}
                            ${demand?.address?.city ? `${demand.address.city} -` : ''}
                            ${demand?.address?.uf ? demand.address.uf : ''}`}</p>
                  <div className="service-date">
                    <p className="title">
                      {demand.status !== ServiceStatus.CANCELED
                        ? 'Prazo de Cumprimento'
                        : 'Cancelado em'}
                    </p>
                    <p>
                      {new Date(demand.dateLimit).toLocaleDateString('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                      })}
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="container-header">
                <SubtitlesIcon className="icon-header" />
                <div className="containerGrid">
                  <div className="containerStatus">
                    {Object.keys(labelServiceStatus)
                      .filter((s) => Number(s) === Number(demand.status))
                      .map((status) => (
                        <p className="statusCard" key={status + uuid}>
                          Status: {labelServiceStatus[status as unknown as ServiceStatus]}
                        </p>
                      ))}
                    <p className="protocol">Número de Protocolo: {demand.protocolNumber}</p>
                  </div>
                  <p className="title">{demand.correspondence.name}</p>
                  {demand.status === ServiceStatus.CONCLUED && !isOpenInformation && (
                    <p className="createdAt">
                      Criada em:{' '}
                      <span>
                        {new Date(demand.createdAt).toLocaleDateString('pt-BR', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                        })}{' '}
                      </span>
                    </p>
                  )}
                </div>
              </div>
            )}
            <div className="containerButton">
              <IconButton onClick={() => handleOpenMoreInformationSolicitation(demand)}>
                {isOpenInformation ? (
                  <KeyboardDoubleArrowUpIcon />
                ) : (
                  <KeyboardDoubleArrowDownIcon />
                )}
              </IconButton>
            </div>
          </Header>
          {isOpenInformation && (
            <>
              <Content>
                {demand.status !== ServiceStatus.CONCLUED &&
                  demand.status !== ServiceStatus.CANCELED && (
                    <div className="containerCard">
                      <div className="containerOptions">
                        <OptionsEventSolicitations
                          zIndex={zIndex}
                          solicitation={demand}
                          handleChangeHistoricVisible={(e) => setIsOpenHistoric(e)}
                          isDemand
                        />
                      </div>
                      <div className="containerCenterSolicitation">
                        <SolicitationContentData
                          isDemand
                          solicitation={demand}
                          isVisible={!isOpenHistoric}
                        />
                        <HistoricService service={demand} isVisible={isOpenHistoric} />
                      </div>
                      <div className="containerAdditionalValue">
                        <div className="contentAdditionalValue">
                          <h1>Valor</h1>
                          <p>R$ {demand.value}</p>
                        </div>
                      </div>
                    </div>
                  )}
              </Content>
              {demand.status === ServiceStatus.IN_PROGRESS && (
                <div className="buttons">
                  <Button
                    text="Cancelar"
                    dimensions={{ width: '8rem', height: '2rem' }}
                    color="text_gray"
                    backgroundHoverColor="transparent"
                    border={{ color: 'transparent', width: 1 }}
                    background="transparent"
                    textHoverColor="gray_300"
                    style={{ textDecoration: 'underline' }}
                    onClick={() => setIsOpenCancel(true)}
                  />
                  <div className="buttons-demand">
                    {!demand.isOff ? (
                      isOpenHistoric ? (
                        <Button
                          text="Voltar"
                          dimensions={{ width: '12rem', height: '2rem' }}
                          color="primary"
                          backgroundHoverColor="primary"
                          border={{ color: 'primary', width: 1 }}
                          textHoverColor="background_white"
                          onClick={() => setIsOpenHistoric(false)}
                        />
                      ) : (
                        <>
                          <Button
                            text="Concluir"
                            dimensions={{ width: '12rem', height: '2rem' }}
                            color="background_white"
                            backgroundHoverColor="tertiary_500"
                            border={{ color: 'transparent', width: 1 }}
                            background="primary"
                            textHoverColor="background_white"
                            onClick={() => setIsOpenFinalizeDemand(true)}
                          />
                          {/* <Button
                            color="background_white"
                            backgroundHoverColor="tertiary_500"
                            background="primary"
                            text="localização"
                            dimensions={{ width: '12rem', height: '2rem' }}
                            onClick={() => setIsOpenLocation(true)}
                          /> */}
                        </>
                      )
                    ) : (
                      <Button
                        text="Voltar"
                        dimensions={{ width: '12rem', height: '2rem' }}
                        color="primary"
                        backgroundHoverColor="primary"
                        border={{ color: 'primary', width: 1 }}
                        textHoverColor="background_white"
                        onClick={() => setIsOpenHistoric(false)}
                      />
                    )}
                  </div>
                </div>
              )}
              {(demand.status === ServiceStatus.CANCELED ||
                demand.status === ServiceStatus.CONCLUED) && (
                <>
                  <div className="containerDataSolicitation">
                    <SolicitationContentData isDemand solicitation={demand} isVisible />
                    <TradingSolicitation solicitation={demand} isVisible />
                  </div>
                  <ButtonMUI
                    onClick={handleClickOpenHistoricCanceledDemand}
                    className="btnHistoric">
                    {isOpenHistoricCanceledDemand ? (
                      <>
                        <CloseIcon /> Fechar Histórico
                      </>
                    ) : (
                      <>
                        <HistoryIcon />
                        Ver Histórico
                      </>
                    )}
                  </ButtonMUI>
                  <HistoricService service={demand} isVisible={isOpenHistoricCanceledDemand} />
                </>
              )}
            </>
          )}
          {isOpenFinalizeDemand && (
            <ModalFinalizeDemand
              isOpen={isOpenFinalizeDemand}
              onRequestClose={() => setIsOpenFinalizeDemand(false)}
              solicitationId={demand.id as string}
              typeCorrespondenceService={demand.correspondence?.type}
            />
          )}
          {demand.id && (
            <ModalCancelDemandInProgress
              isOpen={isOpenCancel}
              onRequestClose={() => setIsOpenCancel(false)}
              demandId={demand.id}
            />
          )}
          {isOpenLocation && (
            <SolicitationMapLocation
              solicitationId={demand.id}
              address={demand.address}
              isOpen={isOpenLocation}
              onClose={() => setIsOpenLocation(false)}
              destinationName={demand.createdBy?.name ?? ''}
              originName={`${user.firstName} ${user.lastName}`}
              type="sender"
            />
          )}
          {conversationIdSelected && (
            <ModalChat
              isOpen={isOpenChat}
              onRequestClose={() => setIsOpenChat(false)}
              conversationId={conversationIdSelected}
            />
          )}
        </>
      )}
    </Container>
  );
}
